import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatUsd } from "@/lib/statsFormat";
import type { CallStatsTotals } from "@/services/callStatsService";

interface CostBreakdownProps {
  totals: CallStatsTotals;
}

const CostBreakdown = ({ totals }: CostBreakdownProps) => {
  const parts = [
    { label: "LLM", value: totals.cost_llm, color: "var(--chart-1)" },
    { label: "STT", value: totals.cost_stt, color: "var(--chart-2)" },
    { label: "TTS", value: totals.cost_tts, color: "var(--chart-3)" },
  ];
  const sum = parts.reduce((acc, part) => acc + part.value, 0);
  const knownPct =
    totals.calls > 0 ? (totals.cost_known_calls / totals.calls) * 100 : 100;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cost breakdown</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex h-3 w-full overflow-hidden rounded-full bg-muted">
          {parts.map((part) => (
            <div
              key={part.label}
              style={{
                width: sum > 0 ? `${(part.value / sum) * 100}%` : 0,
                background: part.color,
              }}
            />
          ))}
        </div>
        <ul className="space-y-2 text-sm">
          {parts.map((part) => (
            <li key={part.label} className="flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span
                  className="size-2.5 rounded-full"
                  style={{ background: part.color }}
                />
                {part.label}
              </span>
              <span className="tabular-nums">
                {formatUsd(part.value)}
                <span className="ml-2 text-muted-foreground">
                  {sum > 0 ? `${((part.value / sum) * 100).toFixed(0)}%` : "—"}
                </span>
              </span>
            </li>
          ))}
        </ul>
        {totals.calls > 0 && knownPct < 100 && (
          <p className="text-xs text-muted-foreground">
            cost known for {Math.floor(knownPct)}% of calls in range
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default CostBreakdown;
